module.exports = __webpack_public_path__ + "img/dhfesta_logo.2d4e0f25.png";